import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';
import { AuthGuard } from './_guards/auth.guard';
import { NoColaborateGuard } from './_guards/no-colaborate.guard';
import { RegisterComponent } from './register';
import { LoginComponent } from './login';
import { ChangelogComponent } from './changelog/changelog.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { ClientListComponent } from './pages/clients/client-list/client-list.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const appRoutes: Routes = [
  // Public layout
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: 'forgot', component: RecoverPasswordComponent },
      { path: 'resetPassword', component: ResetPasswordComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'login', component: LoginComponent },
      { path: '', component: LoginComponent }
    ]
  },
  // Private layout
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      { path: 'logout', component: LoginComponent, canActivate: [AuthGuard] },
      {
        path: 'home', loadChildren: () => import('../app/pages/home/home.module').then(m => m.HomeModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'clients', loadChildren: () => import('../app/pages/clients/clients.module').then(m => m.ClientsModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'departments',
        loadChildren: () => import('./pages/departments/departments.module').then(m => m.DepartmentsModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'collaborators',
        loadChildren: () => import('./pages/collaborators/collaborators.module').then(m => m.CollaboratorsModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'keydrivers',
        loadChildren: () => import('./pages/key-drivers/key-drivers.module').then(m => m.KeyDriversModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'resources',
        loadChildren: () => import('./pages/resources/resources.module').then(m => m.ResourcesModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'actions',
        loadChildren: () => import('./pages/actions/actions.module').then(m => m.ActionsModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'questions',
        loadChildren: () => import('./pages/questions/questions.module').then(m => m.QuestionsModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'polls',
        loadChildren: () => import('./pages/polls/polls.module').then(m => m.PollsModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'pollResponse',
        loadChildren: () => import('./pages/poll-response/poll-response.module').then(m => m.PollResponseModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'pollResponse/:id',
        loadChildren: () => import('./pages/poll-response/poll-response.module').then(m => m.PollResponseModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'profile',
        loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'missions',
        loadChildren: () => import('./pages/missions/missions.module').then(m => m.MissionsModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      },
      {
        path: 'comments',
        loadChildren: () => import('./pages/comments/comments.module').then(m => m.CommentsModule),
        canActivate: [AuthGuard, NoColaborateGuard]
      }
      //{ path: 'collaborators', component: ChangelogComponent, canActivate: [AuthGuard] },
    ],
  },
  // otherwise redirect to home
  { path: '**', redirectTo: 'home' }
];

export const routing = RouterModule.forRoot(appRoutes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top', useHash: true });
